import { render, staticRenderFns } from "./UserDetail_personalTab.vue?vue&type=template&id=11dec452&scoped=true&"
import script from "./UserDetail_personalTab.vue?vue&type=script&lang=js&"
export * from "./UserDetail_personalTab.vue?vue&type=script&lang=js&"
import style0 from "./UserDetail_personalTab.vue?vue&type=style&index=0&id=11dec452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dec452",
  null
  
)

export default component.exports